/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询旗舰店底部内容信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<cms.BottomInfoDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/cms/shop/bottom/content-info`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
